import PropTypes from 'prop-types';

import FaqItem from './FaqItem';

const Faq = ({ offerFaq }) =>
  offerFaq.map(({ title, text }) => (
    <FaqItem key={title} text={text} title={title} />
  ));

Faq.propTypes = {
  offerFaq: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Faq;
